import React from 'react'
import { useNavigate } from 'react-router-dom';

import safetyIcon from '../../../Images/bureauImages/safetyIcon.png'
import timeIcon from '../../../Images/bureauImages/timeIcon.gif'

function ThanksComponent() {
    const navigate = useNavigate();
    const handleHomeClick =()=>{
        let finalUrl = "https://seller.indiamart.com/";
        window.location.href = finalUrl;
    }
    return (
        <>
            <div id='pi-parent'>
                <div className='pi thanks'>
                    <div className='text-parent'>
                        <div><img src={ timeIcon } style={{width:'85px'}}/></div>
                        <div id='text-1'>Thank you for applying 🚀</div>
                        <div id='text-2'>We’re now reviewing your application. Our sales representative will get in touch with you shortly.</div>
                    </div>

                        <div id='goHome' onClick={handleHomeClick}>
                            Go To IndiaMART
                        </div>
                    <div className='safety'>
                        <img src={safetyIcon} />
                        <div id='safety-text'>Your data is 100% safe & secure</div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ThanksComponent